import styled from "@emotion/styled";
import React, { forwardRef } from "react";
import { PolymorphicComponentProps } from "../types";

// Our heading types
interface HeadingOwnProps {
  type?: "heading1" | "heading2";
}

type HeadingProps<T extends React.ElementType> = PolymorphicComponentProps<
  T,
  HeadingOwnProps
>;

// Styled text
const StyledText = styled.span<{ kind?: HeadingOwnProps["type"] }>`
  display: block;
  font-style: normal;
  font-size: var(--text-${({ kind }) => kind}-fontSize);
  font-weight: var(--text-${({ kind }) => kind}-fontWeight);
  line-height: var(--text-${({ kind }) => kind}-lineHeight);
  letter-spacing: var(--text-${({ kind }) => kind}-letterSpacing);
  color: var(--colors-text);

  & a span {
    border-width: 4px;
  }
`;

// Polymorphic Heading
export const Heading = forwardRef(
  <T extends React.ElementType = "h2">(
    { type = "heading2", as, children, ...props }: HeadingProps<T>,
    ref: React.Ref<any>
  ) => {
    return (
      <StyledText
        as={as || (type === "heading1" ? "h1" : "h2")}
        ref={ref}
        kind={type}
        {...props}
      >
        {children}
      </StyledText>
    );
  }
);

Heading.displayName = "Heading";
